import { BaseService } from "core/services";
import { HistoryRouteService } from "application/history/services";

class HistoryService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new HistoryRouteService());
	}

    findFacilityOrderHistory(filter) {
		const url = this.routeService.findFacilityOrderHistory(filter);
		return this.apiClient.get(url);
	}
	
    findNikoOrderHistory(filter) {
		const url = this.routeService.findNikoOrderHistory(filter);
		return this.apiClient.get(url);
	}

	getRecordHistory(params){
		const url = this.routeService.getRecordHistory(params);
		return this.apiClient.get(url);
	}

	getInsuranceChangeHistory(nikoPatientDetailId, fields){
		const url = this.routeService.getInsuranceChangeHistory(nikoPatientDetailId);
		return this.apiClient.post(url, { fields: fields });
	}

	getItemActionHistory(itemId){
		const url = this.routeService.getItemActionHistory(itemId);
		return this.apiClient.get(url);
	}
}

export default HistoryService;